import { render } from "./ShowFilteredVimsottariDasas.vue?vue&type=template&id=ed8ae54c&scoped=true"
import script from "./ShowFilteredVimsottariDasas.vue?vue&type=script&lang=js"
export * from "./ShowFilteredVimsottariDasas.vue?vue&type=script&lang=js"

import "./ShowFilteredVimsottariDasas.vue?vue&type=style&index=0&id=ed8ae54c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8ae54c"]])

export default __exports__